export default __webpack_public_path__ + "static/media/SS13-min.2c0e5582.jpg";